import { render, staticRenderFns } from "./createUserModal.vue?vue&type=template&id=6c1f298a&scoped=true"
import script from "./createUserModal.vue?vue&type=script&lang=js"
export * from "./createUserModal.vue?vue&type=script&lang=js"
import style0 from "./createUserModal.vue?vue&type=style&index=0&id=6c1f298a&prod&scoped=true&lang=less"
import style1 from "./createUserModal.vue?vue&type=style&index=1&id=6c1f298a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f298a",
  null
  
)

export default component.exports